// extracted by mini-css-extract-plugin
export default {"container":"InfoHouse_container__MyIFt","textContainer":"InfoHouse_textContainer__us28s","title":"InfoHouse_title__nNFfF"};